import { LegacyRef, forwardRef } from "react";
import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "./AscCertificateToDowloadCard.module.scss";
import { ReactComponent as CertifacateBackgroundDecor } from "../../../assets/illustrations/certificate-background-decor.svg";
import { ReactComponent as CertifacateBadge } from "../../../assets/illustrations/certificate-badge.svg";
import { ReactComponent as CertifacateSignature } from "../../../assets/illustrations/certificate-signature.svg";
dayjs.extend(relativeTime);

export interface AscCertificateToDowloadCardProps {
  title: string;
  name: string;
  date: string;
  color: "TEAL" | "PINK" | "GREEN" | "PURPLE" | "ORANGE";
  className?: string;
  loading?: boolean;
}

const AscCertificateToDowloadCard = forwardRef(
  (
    {
      title,
      name,
      date,
      color = "GREEN",
      className,
      loading = false,
    }: AscCertificateToDowloadCardProps,
    ref: LegacyRef<HTMLDivElement | null>
  ) => {
    return (
      <div
        ref={ref as LegacyRef<HTMLDivElement>}
        className={classNames(styles.element, className, {
          [styles.teal]: color === "TEAL",
          [styles.pink]: color === "PINK",
          [styles.green]: color === "GREEN",
          [styles.orange]: color === "ORANGE",
          [styles.purple]: color === "PURPLE",
          [styles.loading]: loading,
        })}
      >
        <div className={styles.centerDecorWrapper}>
          <CertifacateBackgroundDecor className={styles.backgroundDecor} />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.certificateText}>
            <div className={styles.certificateTitle}>Certificate</div>
            <div className={styles.certificateSubtitle}>Of reached Skill</div>
            <div className={styles.certificateTitleDecor}>
              <div />
              <div />
              <div />
            </div>
            <div className={styles.certificateName}>{name}</div>
            <div className={styles.certificateDescription}>
              This is certify that you has successfully completed <br /> {title}
              .
            </div>
          </div>
          <div className={styles.bottom}>
            <CertifacateSignature className={styles.certifacateSignature} />
            <div className={styles.date}>
              {dayjs(date).format("D MMM[,] YYYY")}
            </div>
            <CertifacateBadge className={styles.certificateBadge} />
          </div>
        </div>
      </div>
    );
  }
);

export default AscCertificateToDowloadCard;
